
  <div class="row">
    <div class="col-sm-12">
      <app-metadata-dynamic-form *ngIf="metadata && metadata.length > 0" [metadataList]="metadata"
        (metadataListChange)="retrieveMetadataExt($event)"
        (formChange)="retrieveFormValid($event)"></app-metadata-dynamic-form>
      <p *ngIf="!metadata || metadata.length == 0">Nessun campo personalizzato associato al tipo pratica.</p>
    </div>
  </div>
